/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable func-names */
import EDC from '../../../shared/globals';

EDC.Animations.Comet = function (scene) {
  this.scene = scene;
  this.comet = null;
  this.C_FLY_TIME = 1000;
  this.C_FLY_DELAYS = [200, 400, 600, 800];
  this.flyTween = null;
};

EDC.Animations.Comet.prototype.create = function () {
  this.comet = this.scene.add.sprite(0, 0, 'comet');
  this.comet.play('cometFly');
  return this;
};

EDC.Animations.Comet.prototype.place = function (x, y) {
  this.comet.setPosition(x, y);
};

EDC.Animations.Comet.prototype.getWidth = function (x, y) {
  return this.comet.width;
};

EDC.Animations.Comet.prototype.flyTo = function (x, y, completeCallback) {
  const rndIdx = Math.floor(Math.random() * this.C_FLY_DELAYS.length);
  const additionalDelay = this.C_FLY_DELAYS[rndIdx];

  this.flyTween = this.scene.tweens.add({
    targets: this.comet,
    x: x,
    y: y,
    duration: this.C_FLY_TIME + additionalDelay,
    ease: 'Linear',
    onComplete: function () {
      if (completeCallback) {
        completeCallback();
      }
      this.destroy();
    }.bind(this),
  });
};

EDC.Animations.Comet.prototype.destroy = function () {
  this.comet.destroy();
};

export default EDC.Animations.Comet;
